<template>
  <pre>{{ JSON.stringify(raw, null, 2) }}</pre>
</template>

<script>
export default {
  name: 'RawJson',
  props: {
    raw: Object
  }
}
</script>
